const trips = {
  table: {
    headers: {
      from: 'Abholort',
      to: 'Lieferort',
      seats: 'Artikelmenge',
      passenger: 'Name des Empfängers',
    },
  },
};

export default trips;
